interface Props {
  mensaje?: string
}

/**
 * Indicador de espera sobrio. `role="status"` con `aria-live="polite"` para que
 * los lectores de pantalla anuncien el cambio sin interrumpir lo que se este
 * leyendo. Sin emojis: el giro es CSS puro.
 */
export function Cargando({ mensaje }: Props) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-40 flex-col items-center justify-center gap-3 p-8 text-tinta-apagada"
    >
      <span
        aria-hidden="true"
        className="size-6 animate-spin rounded-full border-2 border-borde-fuerte border-t-acento"
      />
      <span className="text-sm">{mensaje ?? 'Cargando'}</span>
    </div>
  )
}
